import PropTypes from 'prop-types';
import Select from 'react-select';
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import { isUserAllowed } from "../../../shared/utils";
import { ROLES } from "../../../helper/constants";

const ContactModalAdressesForm = ({ onChangeAddress, onRemoveAddress, modalData, address, index }) => (
  <Row key={index} className="mt-6 crm-contact-modal-forms-container">
    <Col sm="4">
      <FormGroup>
        <Label className="label_autofin" for="profile">Calle</Label>
        <Input
          className="mb-2"
          onChange={onChangeAddress('street', index)}
          value={address.street}
          placeholder="Calle"
          maxLength="50"
          required
          disabled={isUserAllowed(ROLES.auditor)}
        />
      </FormGroup>
    </Col>
    <Col sm="3">
      <FormGroup>
        <Label className="label_autofin" for="profile">Región</Label>
        <Select
          options={modalData.regions}
          type="text"
          name="region"
          id="region"
          placeholder="seleccionar"
          value={address.region}
          onChange={onChangeAddress('region', index)}
          required
          isDisabled={isUserAllowed(ROLES.auditor)}
        />
      </FormGroup>
    </Col>
    <Col sm="3">
      <FormGroup>
        <Label className="label_autofin" for="profile">Comuna</Label>
        <Select
          options={address.coptions}
          type="text"
          name="commune"
          id="commune"
          placeholder="seleccionar"
          value={address.commune}
          isClearable="true"
          onChange={onChangeAddress('commune', index)}
          isDisabled={isUserAllowed(ROLES.auditor)}
          required
        />
      </FormGroup>
    </Col>
    {!isUserAllowed(ROLES.auditor) && <Col sm="1" className="mt-4">
      <button className="mb-2 plus_add2" onClick={onRemoveAddress(index)} size="sm">
        <span className="lnr lnr-lnr lnr-trash" style={{ fontWeight: 'bold', cursor: 'pointer' }} />
      </button>
    </Col>}
  </Row>
)

ContactModalAdressesForm.propTypes = {
  onChangeAddress: PropTypes.func,
  onRemoveAddress: PropTypes.func,
  modalData: PropTypes.shape({
    regions: PropTypes.string,
  }),
  address: PropTypes.shape({
    coptions: PropTypes.array,
    commune: PropTypes.string,
    region: PropTypes.string,
    street: PropTypes.string,
  }),
  index: PropTypes.number,
};

export default ContactModalAdressesForm;